
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guiarent",
      function () {
        return require("private-next-pages/guiarent/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guiarent"])
      });
    }
  